import React, { Fragment, useEffect, useRef, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "./managerAppointment.css";

function formatMobileNumber(number) {
  // Remove all non-digit characters
  const cleaned = number.replace(/\D/g, "");

  // If number starts with 0, remove it
  if (cleaned.startsWith("0")) {
    return cleaned.substring(1);
  }

  // If number starts with country code (966), remove it
  if (cleaned.startsWith("966")) {
    return cleaned.substring(3);
  }

  return cleaned;
}

const isValidServiceType = (type) => type !== "";
const isValidName = (name) => name.trim() !== "";
// const isValidMobileNumber = (number) => /^05\d{8}$/.test(number);
const isValidMobileNumber = (number) => {
  // Basic validation - at least 9 digits after cleaning
  const cleaned = number.replace(/\D/g, "");
  return cleaned.length >= 9;
};
const isValidCity = (city) => city !== "";
const isValidDistrict = (district) => district.trim() !== "";
const isValidAcType = (acType) => acType !== "";
const isValidCount = (count) => /^[1-9]\d*$/.test(count);
// const isValidSelectedFile = (selectedFile) => selectedFile !== null;
const isValidNotice = (notice) => notice.trim() !== "";
const isValidWarranty = (status) => status !== "";

const ManagerAppointment = () => {
  const token = localStorage.getItem("token");
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      // setSelectedFileError("");
    } else {
      setSelectedFile(null);
      // setSelectedFileError("برجاء رفع صورة الفاتورة");
    }
  };

  const [isSending, setIsSending] = useState(false);
  const [serviceType, setServiceType] = useState("");
  const [name, setName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [region, setRegion] = useState("");
  const [regionId, setRegionId] = useState("");
  const [cityId, setCityId] = useState("");
  const [district, setDistrict] = useState("");
  const [acType, setAcType] = useState("");
  const [notice, setNotice] = useState("");
  const [acCount, setAcCount] = useState("");
  const [data, setData] = useState([]);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAcTypesOpen, setIsAcTypesOpen] = useState(false);
  const [regions, setRegions] = useState([]);
  const [warrantyStatusId, setWarrantyStatusId] = useState("");

  // Error states
  const [nameError, setNameError] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [serviceTypeError, setServiceTypeError] = useState("");
  const [regionError, setRegionError] = useState("");
  const [cityError, setCityError] = useState("");
  const [districtError, setDistrictError] = useState("");
  const [acTypeError, setAcTypeError] = useState("");
  // const [selectedFileError, setSelectedFileError] = useState("");
  const [acCountError, setAcCountError] = useState("");
  const [noticeError, setNoticeError] = useState("");

  const myImageInputRef = useRef(null);
  const acTypesRef = useRef(null);
  const baseUrl = "https://api.generalhome.sa";

  const api = axios.create({
    baseURL: baseUrl,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  // Fetch regions from API
  const fetchRegions = async () => {
    try {
      const response = await axios.get(
        "https://api.generalhome.sa/api/MaintenanceCity/GetMaintenanceMainCities"
      );
      setRegions(response.data);
    } catch (error) {
      toast.error("❌ حدث خطأ أثناء تحميل المناطق");
      console.error("Error fetching regions:", error);
    }
  };

  // Fetch cities by region ID
  const fetchCitiesByRegion = async (mainCityId) => {
    try {
      const response = await api.get(
        `/api/MaintenanceCity/GetallCitiesByMainCityId?MainCityId=${mainCityId}`
      );
      setCities(response.data);
    } catch (error) {
      toast.error("❌ حدث خطأ أثناء تحميل المدن");
      console.error("Error fetching cities:", error);
      setCities([]);
    }
  };

  const uploadImage = async () => {
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await api.post(
        `${baseUrl}/api/Themes/UploadImages`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const imageUrl = response.data?.imageUrl || response.data;
      if (!imageUrl) throw new Error("Failed to upload image");

      const fullImageUrl = imageUrl.startsWith("http")
        ? imageUrl
        : `${baseUrl}${imageUrl.startsWith("/") ? "" : "/"}${imageUrl}`;

      return { success: true, imageUrl: fullImageUrl };
    } catch (error) {
      console.error("Error uploading image:", error);
      if (error.response?.status === 401) {
        Swal.fire({
          icon: "error",
          text: "انتهت جلستك، برجاء تسجيل الدخول مرة أخرى",
        });
      }
      return { success: false, error: "فشل رفع الصورة" };
    }
  };

  const handleAcTypeSelect = (selectedAcType) => {
    setAcType(selectedAcType);
    setAcTypeError("");
    setIsAcTypesOpen(false);
  };

  const getAcTypeName = (id) => {
    const type = data.find((item) => item.ACTypeId === id);
    return type ? type.Name : "";
  };

  const validateForm = () => {
    const nameIsValid = isValidName(name);
    const mobileIsValid = isValidMobileNumber(mobileNumber);
    const serviceTypeIdIsValid = isValidServiceType(serviceType);
    const regionIsValid = isValidName(region);
    const cityIsValid = isValidCity(cityId);
    const districtIsValid = isValidDistrict(district);
    const acTypeIsValid = isValidAcType(acType);
    const acCountIsValid = isValidCount(acCount);
    const noticeIsValid = isValidNotice(notice);
    const warrantyIsValid =
      serviceType === "2" || isValidWarranty(warrantyStatusId);

    setNameError(nameIsValid ? "" : "برجاء ادخال الاسم");
    setMobileNumberError(
      mobileIsValid ? "" : "برجاء ادخال رقم هاتف صحيح (5xxxxxxxx)"
    );
    setServiceTypeError(serviceTypeIdIsValid ? "" : "برجاء اختيار نوع الخدمه");
    setRegionError(regionIsValid ? "" : "برجاء اختيار المنطقة");
    setCityError(cityIsValid ? "" : "برجاء اختيار المدينه");
    setDistrictError(districtIsValid ? "" : "برجاء ادخال اسم الحي");
    setAcTypeError(acTypeIsValid ? "" : "برجاء اختيار نوع المكيف");
    setAcCountError(acCountIsValid ? "" : "برجاء ادخال عدد المكيفات صحيح");
    setNoticeError(noticeIsValid ? "" : "برجاء ادخال الملاحظات");

    return (
      nameIsValid &&
      mobileIsValid &&
      serviceTypeIdIsValid &&
      regionIsValid &&
      cityIsValid &&
      districtIsValid &&
      acTypeIsValid &&
      acCountIsValid &&
      noticeIsValid &&
      warrantyIsValid
    );
  };

  const submit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsSending(true);
    try {
      let imageUrl = null;

      // Upload image only if selected (optional)
      if (selectedFile) {
        const uploadResult = await uploadImage();
        if (!uploadResult.success) {
          Swal.fire({
            icon: "error",
            text:
              uploadResult.error || "فشل رفع الصورة، برجاء المحاولة مرة أخرى",
          });
          setIsSending(false);
          return;
        }
        imageUrl = uploadResult.imageUrl;
      }

      // Format mobile number before sending
      const formattedMobileNumber = formatMobileNumber(mobileNumber);
      const finalWarrantyStatusId =
        serviceType === "2" ? 2 : parseInt(warrantyStatusId);

      const payload = {
        MaintenanceTypeId: parseInt(serviceType),
        CustomerName: name,
        PhoneNumber: formattedMobileNumber,
        Region: region,
        Neighborhood: district,
        CityId: parseInt(cityId),
        ErrorType: notice,
        ACTypeCount: parseInt(acCount),
        ImagePath: imageUrl,
        Details: [
          {
            ACTypeId: parseInt(acType),
            ACTypeCount: 1,
            WarrantyStatusId: finalWarrantyStatusId,
          },
        ],
      };

      const response = await api.post(
        `/api/maintenance/RequestMaintenanceForManager`,
        payload
      );

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          text: response.data.message || "تم ارسال طلبك بنجاح",
        });
        // Reset form
        setName("");
        setMobileNumber("");
        setServiceType("");
        setRegion("");
        setRegionId("");
        setCityId("");
        setDistrict("");
        setAcType("");
        setAcCount("");
        setNotice("");
        setSelectedFile(null);
        if (myImageInputRef.current) myImageInputRef.current.value = "";
      } else {
        Swal.fire({
          icon: "error",
          text: response.data.message || "حدث خطأ، برجاء المحاولة مرة أخرى",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      if (error.response?.status === 401) {
        Swal.fire({
          icon: "error",
          text: "انتهت جلستك، برجاء تسجيل الدخول مرة أخرى",
        });
      } else {
        Swal.fire({
          icon: "error",
          text: "حدث خطأ في الاتصال بالخادم. برجاء المحاولة لاحقاً.",
        });
      }
    } finally {
      setIsSending(false);
    }
  };

  const getAllAcTypes = async () => {
    try {
      const response = await api.get(`/api/ACTypes`);
      setData(response.data);
      setLoading(false);
    } catch (err) {
      console.log(err.message);
      setLoading(false);
      if (err.response?.status === 401) {
        Swal.fire({
          icon: "error",
          text: "انتهت جلستك، برجاء تسجيل الدخول مرة أخرى",
        });
      }
    }
  };

  const buttonRef = useRef(null);

  useEffect(() => {
    getAllAcTypes();
    fetchRegions();

    const handleClickOutside = (event) => {
      if (acTypesRef.current && !acTypesRef.current.contains(event.target)) {
        setIsAcTypesOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Fetch cities when region changes
  useEffect(() => {
    if (regionId) {
      fetchCitiesByRegion(regionId);
      setCityId("");
    } else {
      setCities([]);
      setCityId("");
    }
  }, [regionId]);

  const handleRegionChange = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue === "") {
      setRegion("");
      setRegionId("");
      setRegionError("برجاء اختيار المنطقة");
      return;
    }

    const selectedRegion = regions.find(
      (r) => r.NameMainCity === selectedValue
    );
    if (selectedRegion) {
      setRegion(selectedRegion.NameMainCity);
      setRegionId(selectedRegion.Id);
      setRegionError("");
    }
  };

  return (
    <section className="cleanServAppointment mangerAppointment">
      <Helmet>
        <meta charSet="utf-8" />
        <title>حجز طلب التنظيف</title>
        <link
          rel="canonical"
          href="https://generalhome.sa/cleaning-appointment"
        />
      </Helmet>
      <div className="cleanServAppointment-container container">
        <form onSubmit={submit}>
          <div className="div phoneNum">
            <label htmlFor="serviceType">نوع الخدمة *</label>
            <select
              id="serviceType"
              value={serviceType}
              onChange={(e) => {
                const value = e.target.value;
                setServiceType(value);
                setServiceTypeError("");

                if (value === "2") {
                  setWarrantyStatusId("2");
                } else {
                  setWarrantyStatusId("");
                }
              }}
              className="form-control"
            >
              <option value="">اختر نوع الخدمة</option>
              <option value={1}>صيانه</option>
              <option value={2}>تنظيف</option>
            </select>
            {serviceTypeError && (
              <p className="text-danger">{serviceTypeError}</p>
            )}
          </div>
          <div className="inputs-box inputs-box1">
            <div className="div">
              <label htmlFor="name">الاسم *</label>
              <input
                placeholder="الاسم"
                type="text"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setNameError("");
                }}
              />
              {nameError && <p className="text-danger">{nameError}</p>}
            </div>
            <div className="div phoneNum">
              <label htmlFor="number">رقم الهاتف *</label>
              <input
                placeholder="5xxxxxxxx"
                type="text"
                value={mobileNumber}
                onChange={(e) => {
                  setMobileNumber(e.target.value);
                  setMobileNumberError("");
                }}
              />
              {mobileNumberError && (
                <p className="text-danger">{mobileNumberError}</p>
              )}
            </div>
          </div>
          <div className="inputs-box">
            <div className="div">
              <label htmlFor="region">المنطقة *</label>
              <select id="region" value={region} onChange={handleRegionChange}>
                <option value="">اختر المنطقة</option>
                {regions.map((region) => (
                  <option key={region.Id} value={region.NameMainCity}>
                    {region.NameMainCity}
                  </option>
                ))}
              </select>
              {regionError && <p className="text-danger">{regionError}</p>}
            </div>

            <div className="div">
              <label htmlFor="city">المدينة *</label>
              <select
                id="city"
                value={cityId}
                onChange={(e) => {
                  setCityId(e.target.value);
                  setCityError("");
                }}
                disabled={!regionId}
              >
                <option value="">اختر المدينة</option>
                {cities.map((city) => (
                  <option key={city.Id} value={city.Id}>
                    {city.Name}
                  </option>
                ))}
              </select>
              {cityError && <p className="text-danger">{cityError}</p>}
            </div>

            <div className="div">
              <label htmlFor="district">الحي *</label>
              <input
                className="w-100"
                placeholder="الحي"
                type="text"
                value={district}
                onChange={(e) => {
                  setDistrict(e.target.value);
                  setDistrictError("");
                }}
              />
              {districtError && <p className="text-danger">{districtError}</p>}
            </div>
          </div>
          <div className="selectionList">
            <div className="selections-box">
              <div className="selection-box mb-3 w-100" ref={acTypesRef}>
                <label htmlFor="acTypes">
                  نوع المكيف <span className="text-danger">*</span>
                </label>
                <div
                  className="ac-types-selector"
                  onClick={() => setIsAcTypesOpen(!isAcTypesOpen)}
                >
                  <div className="ac-types-placeholder">
                    {acType ? getAcTypeName(acType) : "اختر نوع المكيف"}
                  </div>
                  <div
                    className={`ac-types-dropdown ${
                      isAcTypesOpen ? "open" : ""
                    }`}
                  >
                    {data.map((item) => (
                      <div
                        key={item.ACTypeId}
                        className={`ac-types-option ${
                          acType === item.ACTypeId ? "selected" : ""
                        }`}
                        onClick={() => handleAcTypeSelect(item.ACTypeId)}
                      >
                        {item.Name}
                      </div>
                    ))}
                  </div>
                </div>
                {acTypeError && <p className="text-danger">{acTypeError}</p>}
              </div>
            </div>
          </div>
          {serviceType === "1" && (
            <div className="div">
              <label htmlFor="warrantyStatus">
                حالة الضمان <span className="text-danger">*</span>
              </label>

              <select
                id="warrantyStatus"
                value={warrantyStatusId}
                onChange={(e) => setWarrantyStatusId(e.target.value)}
              >
                <option value="">اختر حالة الضمان</option>
                <option value={1}>داخل الضمان</option>
                <option value={2}>خارج الضمان</option>
              </select>
            </div>
          )}
          <div className="div">
            <label htmlFor="acCount">
              عدد المكيفات <span className="text-danger">*</span>
            </label>
            <input
              className="w-100"
              placeholder="عدد المكيفات"
              type="number"
              min="1"
              value={acCount}
              onChange={(e) => {
                setAcCount(e.target.value);
                setAcCountError("");
              }}
            />
            {acCountError && <p className="text-danger">{acCountError}</p>}
          </div>
          <div>
            <label className="d-block mb-2">صورة الفاتورة </label>
            <input
              type="file"
              name="image"
              className="form-control-file border-0"
              id="myImageInput"
              onChange={handleFileChange}
              ref={myImageInputRef}
              accept="image/jpeg, image/png, image/gif"
            />
          </div>
          <div className="textarea-box">
            <label htmlFor="textarea">وصف المشكله</label>
            <textarea
              name="textarea"
              placeholder="إكتب وصف المشكله...."
              value={notice}
              onChange={(e) => {
                setNotice(e.target.value);
                setNoticeError("");
              }}
            ></textarea>
            {noticeError && <p className="text-danger">{noticeError}</p>}
          </div>
          <div className="modal-actions">
            <button
              ref={buttonRef}
              id="myButton"
              type="submit"
              disabled={isSending}
              className={isSending ? "disabled-style" : ""}
            >
              {isSending ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  جاري الارسال...
                </>
              ) : (
                "ارسال"
              )}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ManagerAppointment;
